import { IIcon } from '~/components/ui/Icon'

export default function Check({ size, color }: Pick<IIcon, 'size' | 'color'>) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24'>
      {/* Icon from Solar by 480 Design - https://creativecommons.org/licenses/by/4.0/ */}
      <path
        fill={color}
        fillRule='evenodd'
        d='M18.493 6.935a.75.75 0 0 1 .072 1.058l-7.857 9a.75.75 0 0 1-1.13 0l-3.143-3.6a.75.75 0 0 1 1.13-.986l2.578 2.953l7.292-8.353a.75.75 0 0 1 1.058-.072'
        clipRule='evenodd'
      />
    </svg>
  )
}
